module.exports = __webpack_public_path__ + "static/media/29150029-min.4c2ca548.jpg";